/**
 * Returns timezone offset from defined location to a UTC
 */
export function getTimezoneToUTCOffset(timeZone: string) {
	const date = new Date();

	const dateStringInLocale = 'sv'; // Sweden locale use ISO date format

	let utcDate;
	let tzDate;
	try {
		utcDate = new Date(date.toLocaleString(dateStringInLocale, {timeZone: 'UTC'}));
		tzDate = new Date(date.toLocaleString(dateStringInLocale, {timeZone}));
	} catch (error) {
		console.error(error);
		return null;
	}

	if (tzDate.toString() === 'Invalid Date') {
		console.error(`Can not get timezone offset, date is invalid`);
		return null;
	}

	const offset = tzDate.getTime() - utcDate.getTime();

	//  Round  to minutes
	return Math.round(offset / 1000 / 60) * 60 * 1000;
}

/**
 * Returns timezone offset from defined location to a local one
 */
export function getTimezoneOffsetToLocal(timeZone: string) {
	const utcOffset = getTimezoneToUTCOffset(timeZone);
	if (utcOffset === null) {
		return null;
	}

	return utcOffset + new Date().getTimezoneOffset() * 60 * 1000;
}
